import React from "react";
import EquipoFormMobile from "./EquipoFormMobile";
import EquipoFormDesktop from "./EquipoFormDesktop";
import { useIsMobile } from "../../hooks/useDeviceType";

export default function EquipoForm({ equipo = null, onGuardado, onCancelar }) {
  const isMobile = useIsMobile();
  
  if (isMobile) {
    return <EquipoFormMobile equipo={equipo} onGuardado={onGuardado} onCancelar={onCancelar} />;
  }
  
  return <EquipoFormDesktop equipo={equipo} onGuardado={onGuardado} onCancelar={onCancelar} />;
}
